import { CONFLITO_VERSAO, ErroMotivoPerda } from '@/types/scoreComercial'

/**
 * Leitura do envelope de erro que o interceptor de `api` rejeita
 * (`{ message, status, data: <corpo do backend> }`). O corpo de negócio traz
 * `errorCode`; é por ele (e pelo status) que as telas do Pipeline decidem o que fazer.
 */
export const codigoErroDe = (e: unknown): string | undefined =>
  (e as { data?: { errorCode?: string } })?.data?.errorCode

export const mensagemErroDe = (e: unknown, padrao: string): string =>
  (e as { message?: string })?.message ?? padrao

/** 409 `CONFLITO_VERSAO` (PDF §2.4): a reserva mudou desde que a tela a leu. */
export const ehConflitoVersao = (e: unknown): boolean =>
  (e as { status?: number })?.status === 409 || codigoErroDe(e) === CONFLITO_VERSAO

const ERROS_MOTIVO: ErroMotivoPerda[] = ['MOTIVO_PERDA_OBRIGATORIO', 'MOTIVO_PERDA_OBSERVACAO_OBRIGATORIA']

/** Erro que o diálogo de perda sabe apontar no campo certo — ou `null` para os demais. */
export const erroMotivoPerdaDe = (e: unknown): ErroMotivoPerda | null => {
  const codigo = codigoErroDe(e)
  return ERROS_MOTIVO.includes(codigo as ErroMotivoPerda) ? (codigo as ErroMotivoPerda) : null
}
